module.exports = __webpack_public_path__ + "img/ruan5.f7f25571.jpg";